import { useEffect, useState } from 'react';
import { GenericAbortSignal } from 'axios';

import { useInfiniteQuery } from '@tanstack/react-query';

import { LocationOptions } from 'models/Location';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const locationsQueryKeys = {
  index: ['locations'] as const,
};

export type IndexParams = {
  search?: string;
} & BaseIndexQueryParams;

export async function indexLocations(params: IndexParams, signal: GenericAbortSignal) {
  return http.get<Paginated<LocationOptions>>('locations', { params, signal }).then((res) => res.data);
}

export const useInfiniteLocations = (params: IndexParams) => {
  const [search, setSearch] = useState<string>();

  const options = useInfiniteQuery({
    queryKey: [locationsQueryKeys.index, { ...params, search }],
    queryFn: ({ signal, pageParam }) => indexLocations({ pageSize: 10, ...params, search, page: pageParam }, signal),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _pages, lastPageParam) => {
      return lastPage.meta.totalPages > lastPageParam ? lastPageParam + 1 : undefined;
    },
    enabled: false,
  });

  useEffect(() => {
    if (search !== undefined) options.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return { options, onDebouncedSearch: setSearch };
};
